import React from 'react';
import './logout_pop_up.less';
import {Link, browserHistory} from 'react-router';
import classNames from 'classnames';
import '../modal/modal.less';

class LogoutPopUp extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
          isOpen : props.isOpen
        }
        this.login = this.login.bind(this);
    }
    login(){
      document.location.href = '/';
    }
    render() {
      const {props} = this;
      let logoutClassName =  props.isOpen ? 'modal-popup logout-popup-wrap': 'modal-popup displayNone'
      return (
        <div className = {logoutClassName} >
          <div className="overlay"></div>
          <div className="modal">
            <div className="content-wrap">
              <div className="content-hdr">Session is Invalid</div>
              <div className = "content">Please login again.</div>
              <div><button className="btn orange" onClick={this.login}>OK</button></div>
            </div>
          </div>
        </div>
      )
    }
}

export default LogoutPopUp;



// WEBPACK FOOTER //
// app/components/logoutPopUp/logout_pop_up.jsx